import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import {
  CandidateApplicationStatus,
  ConvertsToFullTime,
  JobOpeningStatus,
} from "@/types";
import request from "@/lib/api/handler";

export interface MaskedJobOpening {
  id: string;
  role?: string;
  jobDescriptionLink?: string;
  shortDescription?: string;
  keyResponsibilities?: string;
  scopeEngagementDuration?: string;
  scopeTime?: string;
  budgetHourlyRate?: string;
  budgetMonthlyRetainer?: string;
  budgetIsFlexible?: boolean;
  desiredStartDate?: string;
  convertsToFullTime?: ConvertsToFullTime;
  matchCriteria1?: string;
  matchCriteria2?: string;
  matchCriteria3?: string;
  status?: JobOpeningStatus;
  candidates: MaskedCandidateStatus[];
}

export interface MaskedCandidateStatus {
  id: string;
  jobOpeningId: string;
  status?: CandidateApplicationStatus;
  location?: string;
}

export const usePublicOpportunityQuery = (id: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.publicOpportunity(id),
    enabled: Boolean(id),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      return request<MaskedJobOpening>({
        method: "GET",
        path: `/api/jobOpening/${id}/public`,
      });
    },
  });

  return {
    opportunityLoading: isLoading,
    opportunity: data ?? null,
    opportunityError: error ?? null,
  };
};
